import { observable, computed } from 'mobx';
import BaseModalStore from '@src/components/modal-container/base-modal-store';
import { noop } from '@src/utils/common-util';
import { autobind } from 'core-decorators';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';

const language = getLanguageByPath();

export const SHARE_CONFIG = {
  Discord: { name: 'Discord', icon: require('./images/dc.png') },
  YouTube: { name: 'YouTube', icon: require('./images/yt.png') },
  X: { name: 'X', icon: require('./images/x.png') },
  FaceBook: { name: 'FaceBook', icon: require('./images/facebook.png') },
  Twitch: { name: 'Twitch', icon: require('./images/twitch.png') },
  Instagram: { name: 'Instagram', icon: require('./images/instagram.png') },
  TikTok: { name: 'TikTok', icon: require('./images/tiktok.png') },
  Naver: { name: 'Naver', icon: require('./images/naver.png') },
  VK: { name: 'VK', icon: require('./images/vk.png') }
};
// 534
const shareListConfig = {
  en: [
    { channel: SHARE_CONFIG.Discord.name, link: 'https://discord.gg/mechabreak' },
    { channel: SHARE_CONFIG.X.name, link: 'https://x.com/MechaBREAK' },
    { channel: SHARE_CONFIG.YouTube.name, link: 'https://www.youtube.com/@MechaBREAK' },
    { channel: SHARE_CONFIG.FaceBook.name, link: 'https://www.facebook.com/MechaBREAK' },
    { channel: SHARE_CONFIG.Instagram.name, link: 'https://www.instagram.com/mechabreak/' },
    { channel: SHARE_CONFIG.TikTok.name, link: 'https://www.tiktok.com/@mechabreak' },
    { channel: SHARE_CONFIG.Twitch.name, link: 'https://www.twitch.tv/mechabreakofficial' }
  ],
  ja: [
    { channel: SHARE_CONFIG.Discord.name, link: 'https://discord.gg/mechabreak' },
    { channel: SHARE_CONFIG.X.name, link: 'https://x.com/MechaBREAKJP' },
    { channel: SHARE_CONFIG.YouTube.name, link: 'https://www.youtube.com/@MechaBREAKJP' },
    { channel: SHARE_CONFIG.Twitch.name, link: 'https://www.twitch.tv/mechabreakofficial' }
  ],
  ko: [
    { channel: SHARE_CONFIG.Naver.name, link: 'https://game.naver.com/lounge/Mecha_BREAK' },
    { channel: SHARE_CONFIG.Discord.name, link: 'https://discord.gg/mechabreak' },
    { channel: SHARE_CONFIG.X.name, link: 'https://x.com/MechaBREAK_KR' },
    { channel: SHARE_CONFIG.YouTube.name, link: 'https://www.youtube.com/@MechaBREAK_KR' },
    { channel: SHARE_CONFIG.Instagram.name, link: 'https://www.instagram.com/mechabreak/' },
    { channel: SHARE_CONFIG.Twitch.name, link: 'https://www.twitch.tv/mechabreakofficial' }
  ],
  'zh-Hant': [
    { channel: SHARE_CONFIG.Discord.name, link: 'https://discord.gg/6UdhNM8fNw' },
    { channel: SHARE_CONFIG.FaceBook.name, link: 'https://www.facebook.com/profile.php?id=61560861745459' },
    { channel: SHARE_CONFIG.X.name, link: 'https://x.com/MechaBREAKSea' },
    { channel: SHARE_CONFIG.YouTube.name, link: 'https://www.youtube.com/@MechaBREAEK_Sea' },
    { channel: SHARE_CONFIG.Instagram.name, link: 'https://www.instagram.com/mechabreak/' },
    { channel: SHARE_CONFIG.Twitch.name, link: 'https://www.twitch.tv/mechabreakofficial' }
  ],
  es: [
    { channel: SHARE_CONFIG.Discord.name, link: 'https://discord.gg/mechabreak' },
    { channel: SHARE_CONFIG.X.name, link: 'https://x.com/MechaBREAK' },
    { channel: SHARE_CONFIG.YouTube.name, link: 'https://www.youtube.com/@MechaBREAK' },
    { channel: SHARE_CONFIG.FaceBook.name, link: 'https://www.facebook.com/MechaBREAK' },
    { channel: SHARE_CONFIG.Instagram.name, link: 'https://www.instagram.com/mechabreak/' },
    { channel: SHARE_CONFIG.Twitch.name, link: 'https://www.twitch.tv/mechabreakofficial' }
  ],
  pt: [
    { channel: SHARE_CONFIG.Discord.name, link: 'https://discord.gg/mechabreak' },
    { channel: SHARE_CONFIG.X.name, link: 'https://x.com/MechaBREAK' },
    { channel: SHARE_CONFIG.YouTube.name, link: 'https://www.youtube.com/@MechaBREAK' },
    { channel: SHARE_CONFIG.FaceBook.name, link: 'https://www.facebook.com/MechaBREAK' },
    { channel: SHARE_CONFIG.Instagram.name, link: 'https://www.instagram.com/mechabreak/' },
    { channel: SHARE_CONFIG.Twitch.name, link: 'https://www.twitch.tv/mechabreakofficial' }
  ],
  de: [
    { channel: SHARE_CONFIG.Discord.name, link: 'https://discord.gg/mechabreak' },
    { channel: SHARE_CONFIG.X.name, link: 'https://x.com/MechaBREAK' },
    { channel: SHARE_CONFIG.YouTube.name, link: 'https://www.youtube.com/@MechaBREAK' },
    { channel: SHARE_CONFIG.FaceBook.name, link: 'https://www.facebook.com/MechaBREAK' },
    { channel: SHARE_CONFIG.Instagram.name, link: 'https://www.instagram.com/mechabreak/' },
    { channel: SHARE_CONFIG.Twitch.name, link: 'https://www.twitch.tv/mechabreakofficial' }
  ],
  fr: [
    { channel: SHARE_CONFIG.Discord.name, link: 'https://discord.gg/mechabreak' },
    { channel: SHARE_CONFIG.X.name, link: 'https://x.com/MechaBREAK' },
    { channel: SHARE_CONFIG.YouTube.name, link: 'https://www.youtube.com/@MechaBREAK' },
    { channel: SHARE_CONFIG.FaceBook.name, link: 'https://www.facebook.com/MechaBREAK' },
    { channel: SHARE_CONFIG.Instagram.name, link: 'https://www.instagram.com/mechabreak/' },
    { channel: SHARE_CONFIG.Twitch.name, link: 'https://www.twitch.tv/mechabreakofficial' }
  ],
  ru: [
    { channel: SHARE_CONFIG.VK.name, link: 'https://vk.com/mechabreak' },
    { channel: SHARE_CONFIG.YouTube.name, link: 'https://www.youtube.com/@MechaBREAK' },
    { channel: SHARE_CONFIG.Twitch.name, link: 'https://www.twitch.tv/mechabreakofficial' }
  ],
  th: [
    { channel: SHARE_CONFIG.Discord.name, link: 'https://discord.gg/mechabreak' },
    { channel: SHARE_CONFIG.FaceBook.name, link: 'https://www.facebook.com/groups/mechabreakthai' },
    { channel: SHARE_CONFIG.X.name, link: 'https://x.com/MechaBREAK' },
    { channel: SHARE_CONFIG.YouTube.name, link: 'https://www.youtube.com/@MechaBREAK' },
    { channel: SHARE_CONFIG.Instagram.name, link: 'https://www.instagram.com/mechabreak/' },
    { channel: SHARE_CONFIG.Twitch.name, link: 'https://www.twitch.tv/mechabreakofficial' }
  ]
};

class AppointmentSuccessModalStore extends BaseModalStore {
  name = 'success-modal';

  @observable $main = {};

  @observable expandVideoUrl = '';
  @observable closeCallback = noop;

  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }

  @observable email = '';

  @observable discordLink = undefined;
  @observable youtubeLink = undefined;
  @observable twitterLink = undefined;

  @computed
  get itemList() {
    return shareListConfig[language] || [];
  }

  /**
   * 点击跳转
   * @param url
   */
  @autobind
  onRedirectLink(url) {
    if (url) {
      window.open(url);
    }
  }

  /**
   * 点击关闭弹窗
   * 重写关闭事件, 补充了弹窗特定的关闭回调
   */
  onClickClose = () => {
    this.isOpen = false;
    this.isActive = false;

    // 非默认阶段都弹出礼包窗
    !this.$globalStore.isNormalStage && this.$main.cdkModal.open();

    this.closeCallback();
    this.clearStyle();
  };

  cdkModal = null;

  use() {
    super.use();
  }
}

export default AppointmentSuccessModalStore;
